import { Input } from "@/components/Input";
import { SMSButton } from "@/components/SMSButton";
import SubLayout from "@/components/SubLayout";
import { Button, Form } from "antd-mobile";
import { useSetup } from "./logic";
export function PageUserPhone() {
  const store = useSetup();
  return <SubLayout title={"绑定手机号"} footer={<Button className={"common-submit-button"} onClick={() => {
    store.onSubmit();
  }}>
          确定
        </Button>} data-sentry-element="SubLayout" data-sentry-component="PageUserPhone" data-sentry-source-file="index.tsx">
      <Form form={store.form} className={"common-form"} data-sentry-element="Form" data-sentry-source-file="index.tsx">
        <Form.Item name="phoneNumber" label="手机号" extra={<SMSButton sendSMS={store.sendSMS} />} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input type="tel" placeholder="请输入手机号" maxLength={11} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>

        <Form.Item name="smsCode" label="验证码" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="请输入验证码" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>
      </Form>
    </SubLayout>;
}